
  import React, { useState, useEffect } from "react";
  import { BASE_URL } from "../../../constants";
  import axios from 'axios';
  import 'bootstrap/dist/css/bootstrap.min.css';
  //import {Row, Col, Container, Card} from 'react-bootstrap';
  import { Row, Col, Container, Card, Button, InputGroup } from 'react-bootstrap';
  import '../../../CommonCSS/SocietyCSS.css';


  // import Select from 'react-select';

  const Classwise_Subject = () => {

    const [isEditable, setIsEditable] = useState(false);
    const [dropdowns, setDropdowns] = useState({ premTypes: [], mainComp: [] });
    const [ddlStandards, setDdlStandards] = useState([]);
    const [ddlDivisions, setDdlDivisions] = useState([]);
    const [ddlSubjects, setDdlSubjects] = useState([]);
  

    // Header State
    const [headerData, setHeaderData] = useState({
      std_id: '',
      div_id: '',
      year1: '',
      year2: '',
      sub_id: '',
      exam_name: '',
      oral_max: '',
      written_max: '',
    });

    const [savedfromDate, setSavedFromDate] = useState('');
    const [savedendDate, setSavedEndDate] = useState('');
    const [savedYear1, setSavedYear1] = useState('');

    // Child Table Data
    const [childRows, setChildRows] = useState([
      {
        roll_no: '',
        gr_no: '',
        stud_ms_id: '',
        oral_marks: '',
        written_marks: '',
        grade: '',
        grace_marks: '',
        abs_med: '',
      }
    ]);

    const handleHeaderChange = (e) => {
      const { name, value } = e.target;
      setHeaderData(prev => ({ ...prev, [name]: value }));
    };

    const handleChildChange = (index, e) => {
      const { name, value } = e.target;
      const updatedRows = [...childRows];
      updatedRows[index][name] = value;
      setChildRows(updatedRows);
    };


    useEffect(() => {
      const fetchLists = async () => {
        try {
          const stdresult = await axios.get(`${BASE_URL}/api/ddl_all_standards`);
          setDdlStandards(stdresult.data);
          const res = await axios.get(`${BASE_URL}/api/ddl_all_division`);
          setDdlDivisions(res.data || []);
          const subResult = await axios.get(`${BASE_URL}/api/ddl_subjects`);
          setDdlSubjects(subResult.data);

          //        console.log('premtypeRes.data =====> ', premtypeRes.data);
        } catch (err) {
          console.error("Dropdown fetch error:", err);
        }
      };
      fetchLists();
    }, []);

    const addRow = () => {
      const newIndex = childRows.length + 1; // 1-based index
      const newRow = {
        parent_irn: '',
        maintId: '',
        dispOrder: newIndex, // Default to index + 1
        amount: ''
      };
      setChildRows([...childRows, newRow]);
      //setChildRows([...childRows, { parent_irn: '', maintId: '', dispOrder: '', amount: '' }]);
    };

    const removeRow = (index) => {
      const updatedRows = [...childRows];
      updatedRows.splice(index, 1);
      setChildRows(updatedRows);
    };

    const handleNew = () => {
      setIsEditable(true);
      setHeaderData({
        std_id: '',
        div_id: '',
        year1: '',
        year2: '',
        sub_id: '',
        exam_name: '',
        oral_max: '',
        written_max: '',
      });
      setChildRows([{
        roll_no: '',
        gr_no: '',
        stud_ms_id: '',
        oral_marks: '',
        written_marks: '',
        grade: '',
        grace_marks: '',
        abs_med: '',
      }]);
    };

    const handleSave = async () => {

      // if (!headerData.fromDate || !headerData.toDate) {
      //   //speakMessage('From or To Date cannot be left blank.');
      //   alert('From or To Date cannot be left blank !');
      //   return;
      // }
      // else if (headerData.fromDate > headerData.toDate) {
      //   //speakMessage('From cannot be greater than To Date.');
      //   alert('From cannot be greater than To Date !');
      //   return;
      // }
      // else if (!headerData.premiseType || headerData.premiseType === '') {
      //   //speakMessage('Please Select Premise Type');
      //   alert('Please Select Premise Type !');
      //   return;
      // }

      let lv_err_msg = '';

      for (let i = 0; i < childRows.length; i++) {
        if (!childRows[i].maintId || childRows[i].maintId === '') {
          lv_err_msg = 'Please Select Maintenance Component at Row # ' + (i + 1);
          break;
        }
        else if (!childRows[i].dispOrder || childRows[i].maintId === '0') {
          lv_err_msg = 'Please enter Display Order at Row # ' + (i + 1);
          break;


        }
        else if (!childRows[i].amount || childRows[i].amount === '0' || childRows[i].amount < 0) {
          lv_err_msg = 'Please enter Maintenance Amount greater than 0 at Row # ' + (i + 1);
          break;
        }

      }

      if (lv_err_msg) {
        alert(lv_err_msg);
        return;
      }

      let lv_dupl = 0;

      for (let i = 0; i < childRows.length; i++) {
        for (let j = i + 1; j < childRows.length; j++) {
          if (childRows[i].maintId === childRows[j].maintId) {
            lv_dupl = j;
            break;
          }
        }
        if (lv_dupl > 0) {
          break;
        }
      }

      if (lv_dupl > 0) {
        playBeep();
        alert('Duplicate Maintenance Component selected at Row # ' + (lv_dupl + 1));
        return;
      }

      // DB Validation to check if the given From/To dates, Premise Type already exists or not

      const valResp = await axios.get(`${BASE_URL}/api/validate_maint_struct`,
        { params: { p_Year1: savedYear1, p_fromDate: headerData.fromDate, p_toDate: headerData.toDate, p_PremTypeId: headerData.premiseType } });

      if (valResp.data[0].rows_count > 0) {
        playBeep();
        //speakMessage('Maintenance Structure already exists for the given Year, From, To Dates and Premise Type');
        alert('Maintenance Structure already exists for the given Year, From, To Dates and Premise Type !');
        return;
      }

      // console.log('valResp.data ===> ', valResp.data); 
      // console.log('valResp.data[0].rows_count ===> ', valResp.data[0].rows_count); 

      const isConfirmed = window.confirm("Sure you want to Save the record ?");

      if (!isConfirmed) return;

      const structdata = {
        header: headerData,
        details: childRows,
      };

      const response = await axios.post(`${BASE_URL}/api/save_maint_struct`, structdata);

      if (response.data.message === '1') {
        //alert('Maintenance Structure saved successfully !');
        speakMessage('Maintenance Structure saved successfully. Do you like to Add more ?');
        if (window.confirm("Maintenance Structure saved successfully. Do you like to Add more ?")) {
          //headerData.premiseType = '';
          //setDropdowns.premTypes('');
          const updatedChildRows = childRows.map(row => ({
            ...row,
            amount: ''
          }));
          setChildRows(updatedChildRows);
        }
        else {
          setIsEditable(false);
          setHeaderData({
            std_id: '',
            div_id: '',
            year1: '',
            year2: '',
            sub_id: '',
            exam_name: '',
            oral_max: '',
            written_max: '',
          });
          setChildRows([{
            roll_no: '',
            gr_no: '',
            stud_ms_id: '',
            oral_marks: '',
            written_marks: '',
            grade: '',
            grace_marks: '',
            abs_med: '',
          }]);
          headerData.fromDate = savedfromDate;
          headerData.toDate = savedendDate;
        }
      }

    };

    const handleClear = () => {
      if (window.confirm("Clear all data?")) {
        handleNew();
        setIsEditable(false);
      }
    };

    const playBeep = () => {
      const audioCtx = new (window.AudioContext || window.AudioContext)();
      const oscillator = audioCtx.createOscillator();
      const gainNode = audioCtx.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(audioCtx.destination);

      oscillator.type = 'square'; // Other types: sine, square, triangle, sawtooth
      oscillator.frequency.setValueAtTime(440, audioCtx.currentTime); // Frequency in Hz (440Hz = A4 note)
      gainNode.gain.setValueAtTime(0.1, audioCtx.currentTime); // Volume

      oscillator.start();
      oscillator.stop(audioCtx.currentTime + 0.2); // Play for 0.2 seconds
    };

    const speakMessage = (message) => {
      const utterance = new SpeechSynthesisUtterance(message);
      utterance.lang = 'en-US'; // or 'en-GB', 'hi-IN', etc.
      utterance.rate = 1;       // Speed: 0.1 (slow) to 10 (fast)
      utterance.pitch = 1;      // Pitch: 0 to 2
      speechSynthesis.speak(utterance);
    };

    return (
      <Container fluid className="p-3">
        <Card className="mb-4 p-3">

          {<Row className="mb-3">

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "90px" }}>
                  Standard
                </InputGroup.Text>
                <select
                  className="form-select"
                  name="std_id"
                  value={headerData.std_id}
                  disabled={!isEditable}
                // onChange={handleChange}
                >
                  <option value="">-- Select Standard--</option>
                  {ddlStandards.map(std => (
                    <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                  ))}

                </select>
              </InputGroup>
            </Col>


            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "90px" }}>
                  Division
                </InputGroup.Text>
                <select
                  className="form-select"
                  name="div_id"
                  value={headerData.div_id}
                  disabled={!isEditable}
                // onChange={handleChange}
                >
                  <option value="">-- Select Division--</option>
                  {ddlDivisions.map(div => (
                    <option key={div.div_id} value={div.div_id}>{div.div_name}</option>
                  ))}

                </select>
              </InputGroup>
            </Col>

            <Col md={6}>
              <InputGroup>
                <InputGroup.Text style={{ width: "90px" }}>
                  Year 1
                </InputGroup.Text>
                <input
                  type="number"
                  style={{ textAlign: 'right' }}
                  className="form-control"
                  name="year1"
                  value={headerData.year1}
                  disabled={!isEditable}
                // onChange={handleChange}
                />&nbsp;
                <input
                  type="number"
                  style={{ textAlign: 'right' }}
                  className="form-control"
                  name="year2"
                  value={headerData.year2}
                  disabled={!isEditable}
                // onChange={handleChange}
                />
              </InputGroup>
            </Col>

          </Row>}

          <Row className="mb-3">
            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "90px" }}>
                  Subject
                </InputGroup.Text>
                <select
                  className="form-select"
                  name="sub_id"
                  value={headerData.sub_id}
                  disabled={!isEditable}
                // onChange={handleChange}
                >
                  <option value="0">Select Subject </option>
                  {ddlSubjects.map(sub => (
                    <option key={sub.sub_id} value={sub.sub_id}>{sub.sub_desc}</option>
                  ))}

                </select>
              </InputGroup>
            </Col>

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "110px" }}>
                  Exam Name
                </InputGroup.Text>
                <select
                  className="form-select"
                  name="exam_name"
                  value={headerData.exam_name}
                  disabled={!isEditable}
                // onChange={handleChange}
                >
                  <option value="">-- Select Exam--</option>
                  <option value="UNIT-1">Unit Test-1</option>
                  <option value="SEMESTER-1">Semester-1</option>
                  <option value="UNIT-2">Unit Test-2</option>
                  <option value="SEMESTER-2">Semester-2</option>
                  <option value="PRELIUM-1">Prelium-1</option>
                  <option value="PRELIUM-2">Prelium-2</option>

                </select>
              </InputGroup>
            </Col>
            
            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "125px" }}>
                  Oral/Prac Max
                </InputGroup.Text>
                <input
                  type="text"
                  style={{ textAlign: 'right' }}
                  className="form-control"
                  name="oral_max"
                  value={headerData.oral_max}
                  disabled={!isEditable}
                onChange={(e) => handleHeaderChange(e)}
                />
              </InputGroup>
            </Col>

            <Col md={3}>
              <InputGroup>
                <InputGroup.Text style={{ width: "110px" }}>
                  Written Max
                </InputGroup.Text>
                <input
                  type="text"
                  style={{ textAlign: 'right' }}
                  className="form-control"
                  name="written_max"
                  value={headerData.written_max}
                  disabled={!isEditable}
                                onChange={(e) => handleHeaderChange(e)}

                />
              </InputGroup>
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-2 mt-3 flex-wrap">

            <button
              type="button"
              className="btn btn-primary"
              style={{ width: "135px" }}
              onClick={handleNew}
              disabled={isEditable}
            >New
            </button>

            <button
              type="button"
              className="btn btn-secondary"
              style={{ width: "135px" }}
              onClick={handleClear}
            > Clear
            </button>

            <button
              type="button"
              className="btn btn-success"
              style={{ width: "135px" }}
              onClick={handleSave}
              disabled={!isEditable}
            > Save
            </button>
          </div>
        </Card>

        {/* Child Table */}

        <Card className="p-3">
          <div style={{ minHeight: '220px' }} className="table-wrapper">
            <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
              <thead>
                <tr>
                  <th style={{ width: '2%', textAlign: 'center' }}>#</th>
                  <th style={{ width: '6%', textAlign: 'left' }}>Roll No</th>
                  <th style={{ width: '6%', textAlign: 'left' }}>Gr No</th>
                  <th style={{ width: '20%', textAlign: 'left' }}>Student Name</th>
                  <th style={{ width: '8%', textAlign: 'right' }}>Oral/Pract Marks</th>
                  <th style={{ width: '8%', textAlign: 'right' }}>Written Marks</th>
                  <th style={{ width: '8%', textAlign: 'right' }}>Grade</th>
                  <th style={{ width: '8%', textAlign: 'right' }}>Grace Marks </th>
                  <th style={{ width: '8%', textAlign: 'right' }}>Abs/Medical </th>
                </tr>
              </thead>

              <tbody>
                {childRows.map((row, index) => (
                  <tr key={index}>
                    <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>

                    <td>
                      <input style={{ textAlign: 'left' }} disabled={!isEditable}
                        type="text" className="form-control" name="roll_no" value={row.roll_no} onChange={(e) => handleChildChange(index, e)} />
                    </td>
                    <td>
                      <input style={{ textAlign: 'left' }} disabled={!isEditable}
                        type="text" className="form-control" name="gr_no" value={row.gr_no} onChange={(e) => handleChildChange(index, e)} />
                    </td>
                    <td>
                      <input style={{ textAlign: 'left' }} disabled={!isEditable}
                        type="text" className="form-control" name="stud_ms_id" value={row.stud_ms_id} onChange={(e) => handleChildChange(index, e)} />
                    </td>
                    <td>
                      <input style={{ textAlign: 'right' }} disabled={!isEditable}
                        type="text" className="form-control" name="oral_marks" value={row.oral_marks} onChange={(e) => handleChildChange(index, e)} />
                    </td>
                    <td>
                      <input style={{ textAlign: 'right' }} disabled={!isEditable}
                        type="number" className="form-control" name="written_marks" value={row.written_marks} onChange={(e) => handleChildChange(index, e)} />
                    </td>
                    <td>
                      <select className="form-select" disabled={!isEditable}
                        name="grade" value={row.grade} onChange={(e) => handleChildChange(index, e)}>
                        <option value="0"> </option>
                      </select>
                    </td>
                    <td>
                      <input style={{ textAlign: 'rleftght' }} disabled={!isEditable}
                        type="text" className="form-control" name="grace_marks" value={row.grace_marks} onChange={(e) => handleChildChange(index, e)} />
                    </td>
                    <td>
                      <select className="form-select" disabled={!isEditable}
                        name="abs_med" value={row.abs_med} onChange={(e) => handleChildChange(index, e)}>
                        <option value="0"> </option>
                      </select>
                    </td>

                    {/* <td style={{ textAlign: 'center' }}>
                      {childRows.length > 1 && (
                        <Button variant="danger" onClick={() => removeRow(index)} size="sm">Delete</Button>
                      )}
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* <div className="mb-3">
            <Button disabled={!isEditable} style={{ marginTop: '10px' }} variant="primary" onClick={addRow}>Add Row</Button>
          </div> */}
        </Card>

        {/* Buttons */}
      </Container>
    );
  };

  export default Classwise_Subject;
